import React, { Component } from 'react';
import { isEmail } from 'validator';

import memoizeOne from 'memoize-one';
import _memoize from 'lodash.memoize';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import {
  Button,
  Input,
  PhoneNumberInput,
  LocationSelector,
  Text } from
'../../../ui-kit';
import SocialProfiles from '../../SocialProfiles';
import '../styles/_basic-user-profile.scss';














































const isValidEmail = memoizeOne(isEmail);

function getDefaultUserStringValue(user) {
  return (key) => user && user[key] || '';
}

export default class BasicUserProfile extends Component


{
  updateInputField = _memoize((fieldName) => (result) => {
    this.setState({ [fieldName]: getStringValueFromGenericInput(result) });
  });

  static defaultProps = { saveBtnText: 'Save & Continue' };

  onValidatePhoneNumber = _memoize((numberType) => (valid) => {
    this.setState({ [`${numberType}Valid`]: valid });
  });

  constructor(props) {
    super(props);

    const { user = {} } = props;
    const getDefaultVal = getDefaultUserStringValue(user);

    this.state = {
      imageUrl: getDefaultVal('imageUrl'),
      firstName: getDefaultVal('firstName'),
      lastName: getDefaultVal('lastName'),
      jobTitle: getDefaultVal('jobTitle'),
      department: getDefaultVal('department'),
      email: getDefaultVal('email'),
      phoneNumber: getDefaultVal('phoneNumber'),
      socialProfiles: { linkedIn: getDefaultVal('linkedInUrl') },
      location: user.location,
      imageFile: void 0,
      phoneNumberValid: true,
      isValidAddress: Boolean(user.location)
    };
  }

  updateLocation = (
  updatedLocation,
  { isValidAddress }) =>
  {
    const { location } = this.state;

    const addressId = location && location.addressId ? location.addressId : null;

    this.setState({
      location: { addressId, ...updatedLocation },
      isValidAddress
    });
  };

  handleSelectImage = (files) => {
    if (files.length < 1) {
      return;
    }

    const [file] = files.slice(-1);
    this.setState({
      imageUrl: file.preview.url,
      imageFile: file
    });
  };

  onSave = async () => {
    const { onSave } = this.props;
    const {
      phoneNumber,
      socialProfiles,
      phoneNumberValid,
      isValidAddress,
      ...state
    } = this.state;

    await onSave({
      ...state,
      phoneNumber,
      linkedInUrl: socialProfiles.linkedIn || ''
    });
  };

  isValidUser() {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      jobTitle,
      phoneNumberValid
    } = this.state;

    return (
      firstName &&
      lastName &&
      email &&
      phoneNumber &&
      phoneNumberValid &&
      jobTitle);

  }

  isValidFirstTimeUser() {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      phoneNumberValid
    } = this.state;

    return firstName && lastName && email && phoneNumber && phoneNumberValid;
  }

  render() {
    const {
      socialProfiles,
      firstName,
      lastName,
      email,
      jobTitle,
      phoneNumber,
      department,
      imageUrl,
      location,
      isValidAddress
    } = this.state;
    const {
      saveBtnText,
      saving,
      error,
      isFirstTimeSetup,
      firstTimeSubtitle,
      isFromSelfSignUp,
      isV2Design
    } = this.props;

    return (
      <div className="basic-user-profile-container">
        {isFirstTimeSetup ?
        <div className="basic-user-profile">
            <div className="basic-user-profile__fields-container">
              <Text
              className={
              isV2Design ?
              'basic-user-profile__v2_subtitle' :
              'basic-user-profile__subtitle'}>


                {firstTimeSubtitle}
              </Text>
              <div className="basic-user-profile__split-row">
                <Input
                id="firstname-input"
                placeholder="First"
                label="First Name"
                labelProps={{ required: true }}
                onChange={this.updateInputField('firstName')}
                defaultValue={firstName} />

                <Input
                id="lastname-input"
                placeholder="Last"
                label="Last Name"
                labelProps={{ required: true }}
                onChange={this.updateInputField('lastName')}
                defaultValue={lastName} />

              </div>
              <PhoneNumberInput
              id="contactnumber-input"
              placeholder="xxxx-xxx-xxx"
              label="Phone Number"
              labelProps={{ required: true }}
              onChange={this.updateInputField('phoneNumber')}
              onValidate={this.onValidatePhoneNumber('phoneNumber')}
              initialNumber={phoneNumber}
              emptyIsValid />

              {!isV2Design &&
            <Input
              id="email-input-v2"
              placeholder="Enter email"
              label={
              isFromSelfSignUp ?
              'Organisation Email Address' :
              'Email Address'}

              labelProps={{ required: true }}
              validate={isValidEmail}
              onChange={this.updateInputField('email')}
              errorMessage="Please enter a valid email address"
              defaultValue={email}
              disabled />}


            </div>
            {error ? <Text danger>{error}</Text> : null}
            <Button
            data-cy="profile-submit-button"
            busy={Boolean(saving)}
            onClick={this.onSave}
            disabled={!(this.isValidFirstTimeUser() && isValidEmail(email))}>

              {saveBtnText}
            </Button>
          </div> :

        <div className="basic-user-profile">
            <SocialProfiles
            className="basic-user-profile__details"
            title="User Profile"
            socialProfiles={socialProfiles}
            onSave={this.updateInputField('socialProfiles')}
            defaultImage="user"
            imagePlaceholder={`${firstName} ${lastName}`}
            modalTitle="LinkedIn Profile"
            buttonTitle="LinkedIn"
            allowedSocialTypes={['linkedIn']}
            onSelectImage={this.handleSelectImage}
            profileImage={imageUrl} />

            <div className="basic-user-profile__fields-container">
              <div className="basic-user-profile__split-row">
                <Input
                id="firstname-input"
                placeholder="Enter first name"
                label="First Name"
                labelProps={{ required: true }}
                onChange={this.updateInputField('firstName')}
                defaultValue={firstName} />

                <Input
                id="lastname-input"
                placeholder="Enter last name"
                label="Last Name"
                labelProps={{ required: true }}
                onChange={this.updateInputField('lastName')}
                defaultValue={lastName} />

              </div>
              <div>
                <Input
                id="email-input"
                placeholder="Enter email"
                label="Email Address"
                labelProps={{ required: true }}
                validate={isValidEmail}
                onChange={this.updateInputField('email')}
                errorMessage="Please enter a valid email address"
                defaultValue={email} />

                <div className="basic-user-profile__split-row">
                  <Input
                  id="jobtitle-input"
                  placeholder="Enter job title"
                  label="Job Title"
                  labelProps={{ required: true }}
                  onChange={this.updateInputField('jobTitle')}
                  defaultValue={jobTitle} />

                  <Input
                  id="department-input"
                  placeholder="Enter department"
                  label="Department"
                  onChange={this.updateInputField('department')}
                  defaultValue={department} />

                </div>
              </div>
              <PhoneNumberInput
              id="contactnumber-input"
              placeholder={
              isFirstTimeSetup ? 'xxxx-xxx-xxx' : 'Enter contact number'}

              label="Phone Number"
              labelProps={{ required: true }}
              onChange={this.updateInputField('phoneNumber')}
              onValidate={this.onValidatePhoneNumber('phoneNumber')}
              initialNumber={phoneNumber}
              emptyIsValid />

              <LocationSelector
              id="select-location"
              label="Work Address"
              onSelectAddress={this.updateLocation}
              initialAddress={location}
              labelProps={{ required: true }}
              dropdownType="BUTTON" />

            </div>
            {error ? <Text danger>{error}</Text> : null}
            <Button
            data-cy="profile-submit-button"
            busy={Boolean(saving)}
            onClick={this.onSave}
            disabled={
            !(isValidAddress && this.isValidUser() && isValidEmail(email))}>


              {saveBtnText}
            </Button>
          </div>}

      </div>);

  }
}